<div id="chart">
  <div class="text-center">
    <label><strong class="text-center">{{ chartTitle }}</strong></label>
  </div>

  <apx-chart
    [series]="chartOptions?.series!"
    [chart]="chartOptions?.chart!"
    [labels]="chartOptions?.labels!"
    [colors]="mColors"
    [dataLabels]="dataLabelsConfig"
    [responsive]="chartOptions.responsive!"
  ></apx-chart>

  <!-- Always-visible summary — shows emoji + label + % even when the slice is too small to label -->
  <div class="pie-summary">
    <div *ngFor="let row of summaryRows" class="pie-summary-row">
      <span class="pie-dot" [style.background]="row.color"></span>
      <span class="pie-label">{{ row.label }}</span>
      <span class="pie-pct">{{ row.percentage }}%</span>
    </div>
  </div>
</div>
